import {useEffect, useState} from 'react'
import {Toast, ToastContainer} from 'react-bootstrap'
import {FormattedMessage} from 'react-intl'
import clsx from 'clsx'
import {NotType, usePageData} from '../../layout/core'
import {KTSVG} from '../../helpers'
import {SoundNotification} from './SoundNotification'

export function Notification(data: NotType) {
  const [show, setShow] = useState(true)
  const {removeNotification} = usePageData()
  const {status, type, body, soundSrc, sound = false} = data
  const handleClose = (id: string) => {
    setShow(false)
    removeNotification(id)
  }

  useEffect(() => {
    function play() {
      const audio = document.getElementById('audio')
      // @ts-ignore
      audio?.play()
    }

    play()
  }, [])

  return (
    <>
      {sound && (
        <SoundNotification
          src={
            soundSrc
              ? soundSrc
              : 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
          }
        />
      )}
      {body && (
        <Toast
          show={show}
          onClose={() => handleClose(data.id)}
          delay={3000}
          autohide
          className={`mx-3 my-2 bg-${type} mw-300px ${clsx({'text-dark': type})}`}
        >
          <Toast.Body>
            <div className='modal-dialog modal-dialog-centered'>
              <div className='modal-content text-center h-150px d-flex flex-column align-items-center justify-content-center rounded'>
                <div
                  className={`swal2-icon ${
                    status ? `swal2-${status}` : 'text-dark'
                  } swal2-icon-show`}
                >
                  <div className='swal2-icon-content'>
                    {status === 'success' && '✓'}
                    {(status === 'warning' || status === 'danger') && '!'}
                    {!status && '✓'}
                  </div>
                </div>

                <p className='fs-5 fw-bold text-dark m-0'>
                  <FormattedMessage id={body} defaultMessage={body} />
                </p>
              </div>
            </div>
          </Toast.Body>
        </Toast>
      )}
    </>
  )
}

export function Notifications() {
  const {notifications} = usePageData()
  return (
    <ToastContainer position='middle-center' className='p-3'>
      {notifications?.map((child: NotType) => (
        <Notification key={`${child.id}`} {...child} />
      ))}
    </ToastContainer>
  )
}
